query GetEntityDocument($documentId: UUID!) {
  entityDocument(id: $documentId) {
    id
    entityId
    _entryLayout
    _revisePrivilege
    _unretirePrivilege
    _retirePrivilege
    _documentContents
    _isEnvironmentalsExists
    _isAccountingDocument
    _isDocumentAmountApplied
    isAppliedAmountRetired
    isAppliedAmountOverage
    documentRetiredAmount
    _isDocumentTextExtensionExists
    _documentTextExtension {
    extendedDescription
    isImageDescriptionExists
    isTranslatedDescriptionExists
    sourceLanguage
    translatedDescription
    alternateDescription
    isAlternateDescriptionExists
    }
    entityDocumentTypeId
    fileIndexInformation
    _isDocumentTypeUpdatable
    _poAllocationTotal
    comment
    documentTypeId
    documentStatusType {
      statusType
    }
    _createdByUserName
    _documentType
    _uploadedByUser
    _uploadedByUserid
    _verifiedUserName
    documentStatusExplanation
    documentOverageAmount
    _isDocumentAmountAvailable
    documentAppliedAmounts {
      id
      appliedTotal
      overageTotal
      retiredTotal
      usedTotal
      remainingTotal
      _isRemainingAmountAvailable
      _isRetiringBalanceAllowed
    }
    currency {
      isoCode
    }
    _documentPoolName
    _documentPoolId
    indexName
    indexAmount
    indexCurrencyId
    indexDescription
    indexReferenceNumber
    indexTransactionDate
    _isReportingDocument
    _sharedByUser
    _fileName
    _fileType
    _fileViewer
    _createdDate
    _isDocumentShare
    fileReference
    iconType
    _fileSize
    rowSecurityId
    entityDocumentSecureRowLevels {
      id
      description
      name
      securityLevel
    }
    _uploadDate
    _rowTimestamp
    _isLoading
    _isDeletable
    _isUpdatable
    _isProtected
    _isSelected
    isShareable
    _isLoadFailed
    documentAppliedAmount
    paymentDocument {
      _isApprovalDocumentsRequired
    }
    invoiceDocument {
      _isApprovalDocumentsRequired
    }
    extractionTypeId

    _transactionHistoryId
    extractionType {
      isExtractProtected
    }
    _isVerified
    _documentFileId
    entityDocumentHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    documentTypes {
      id
      documentType
      isAccountingDocument
      isSigningRequired
      _isMultiDocumentBundleAllowed
      _isAppliableDocumentType
      _isDocumentDistributionAllowed
      transactionTypeId
      _isPoSystemDocument
      _isTaxFieldTracked
    }
    lookupName {
      lookupName
      id
      isApprovedVendor
      lookupCode
      lookupName
      lookupName2
      address1
      address2
      city
      state
      zipCode
      country
      phone
      emailAccount
    }
    indexTaxCode1
    indexTaxAmount1
    indexTaxAccount1
    indexTaxCode2
    indexTaxAmount2
    indexTaxAccount2
    indexTaxCode3
    indexTaxAmount3
    indexTaxAccount3
    indexTaxCode4
    indexTaxAmount4
    indexTaxAccount4
    documentFileDistributionsByDocumentFileId(orderBy: _CREATED_DATE_ASC) {
      nodes {
        id
        _createdDate
        _isDeletable
        _isUpdatable
        _rowTimestamp
        accountReference
        _accountName
        projectReference
        setReference
        additionalDescription
        referenceCode1
        referenceCode2
        referenceCode3
        referenceCode4
        referenceCode5
        referenceCode6
        referenceCode7
        distributionAmount
        tax1099T4TypeId
        isInvoiceSelectable
        documentAppliedAmount
        _ff1Name
        _ff2Name
        _ff3Name
        _ff4Name
        distributionDate
      }
      aggregates {
        sum {
          distributionAmount
        }
      }
      totalCount
    }
    _resetAccountingAllowed
    _protectedWithAccountingUpdate
    entityEnvironmentalsByEntityId {
      nodes {
        description
        endDate
        startDate
        _rowTimestamp
        _createdDate
        id
        _isDeletable
        _isUpdatable
        environmentalMetric {
          environmentalMetric
          layoutType
        }
        environmentalMetricId
        entityEnvironmentalItems(
          orderBy: ENVIRONMENTAL_IMPACT_TYPE_BY_ENVIRONMENTAL_IMPACT_TYPE_ID__ENVIRONMENTAL_IMPACT_ASC
        ) {
          nodes {
            carbonCreditsAmount
            entityEnvironmentalId
            environmentalImpactTypeId
            _isIntegerFormat
            _isFloatFormat
            _isAmountFormat
            feet
            gallons
            hours
            id
            kilogram
            kilometers
            kilowattHours
            litres
            meters
            metricTonnes
            miles
            omissionsEquivalent
            pounds
            quantity
            therms
            tons
            yards
            _rowTimestamp
            _isUpdatable
            _isDeletable
            environmentalImpactType {
              environmentalImpact
            }
          }
        }
      }
    }
  }
}
